import { createReducer } from '../../utils/createReducer';
import { WidgetSettings } from '../types';
import { WidgetActions, UPDATE_WIDGET_SETTINGS } from '../actions/types';

const initialState: WidgetSettings = {
  use_button: true,
};

const settingsReducer = {
  [UPDATE_WIDGET_SETTINGS]: (state: WidgetSettings, { settings }: { settings: WidgetSettings }) => ({
    ...state,
    ...settings,
  }),
};

export default (state: WidgetSettings = initialState, action: WidgetActions) => 
  createReducer(settingsReducer, state, action); 
